import { Avatar, Button, Grid2 as Grid, Typography, Box } from '@mui/material';
import { CounterData, PostDetail, UserDetail } from '../types';
import React, { useState } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';
import diamond from '../assets/diamond.json';
import ruby from '../assets/ruby.json';
import silver_star from '../assets/silver.json';
import gold from '../assets/gold.json';
import hof from '../assets/hof.json';
import mp from '../assets/mp.json';
import wnd from '../assets/treasure.json';
import { useNavigate } from 'react-router-dom';
import { GolfCourseRounded } from '@mui/icons-material';
import ProfileImageBlur from './profileImageBlur';

interface UserDetailsProps {
  userData: UserDetail | null;
  isMobile: boolean | null;
  postDetail: PostDetail | null;
  counterData: CounterData | null;
}

const UserDetails: React.FC<UserDetailsProps> = ({ postDetail, userData, isMobile, counterData }) => {
  const [showFullBio, setShowFullBio] = useState(false);
  const navigate = useNavigate();

  const toggleBio = () => {
    setShowFullBio((prev) => !prev);
  };

  const renderBio = (bio: string | undefined) => {
    if (!bio) return '';
    const bioPreview = bio.length > 100 ? bio.substring(0, 100) + '...' : bio;
    return showFullBio ? bio : bioPreview;
  };

  type BadgeKey = 'slv' | 'dia' | 'rby' | 'gld' | 'hof' | 'mp' | 'wnd';

  const badgeMap: Record<BadgeKey, any> = {
    slv: silver_star,
    dia: diamond,
    rby: ruby,
    gld: gold,
    hof: hof,
    mp: mp,
    wnd: wnd
  };
  const badgeKey = counterData?.badge?.S as BadgeKey;
  const showDiamond = ['hof', 'wnd', 'mp'].includes(badgeKey);

  return (
    <Grid
      container
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        zIndex: 10,
        color: isMobile ? 'black' : 'white',
        padding: isMobile ? 0 : '15px',
        width: '100%'
      }}
      alignItems="center">
      {!isMobile ? (
        <>
          <Grid size={{ xs: 2, md: 1 }}>
            <Box></Box>
            {/* <Avatar
              alt={userData?.handle}
              src={
                userData?.defaultAvatar
                  ? `${process.env.REACT_APP_DEFAULT_AVATAR}/APP/UserAvatars/Avatar2.png`
                  : `${process.env.REACT_APP_DEFAULT_AVATAR}/${userData?.uid}/PROFILE/IMAGES/medium/${userData?.avatar}`
              }
              sx={{ width: 50, height: 50 }}
              onClick={() => navigate(`/user/${userData?.handle}`)}
            /> */}
            <ProfileImageBlur
              defaultAvatar={userData && userData?.defaultAvatar}
              imgHeight={'50px'}
              imgWidth={'50px'}
              uid={userData && userData.uid}
              avatar={userData && userData.avatar}
              handle={userData && userData?.handle}
            />
          </Grid>
          <Grid size={{ xs: 10, md: 11 }}>
            <Typography variant="inherit" gutterBottom>
              {userData?.firstname || 'Anonymous'}
            </Typography>
          </Grid>
          <Grid size={12}>
            <Typography variant="inherit" gutterBottom>
              {renderBio(postDetail?.text)}
              {postDetail?.text?.length && postDetail?.text.length > 100 ? (
                <Button onClick={toggleBio} sx={{ color: 'white', textTransform: 'capitalize' }}>
                  {showFullBio ? 'See Less' : 'See More'}
                </Button>
              ) : null}
            </Typography>
          </Grid>
          <Grid size={{ xs: 2 }} style={{ position: 'absolute', right: '2px' }}>
            {badgeMap[badgeKey] && (
              <Box style={{ display: 'flex' }}>
                {showDiamond && <Player autoplay loop src={diamond} style={{ width: '60px', height: '60px' }} />}
                <Player autoplay loop src={badgeMap[badgeKey]} style={{ width: '60px', height: '60px' }} />
              </Box>
            )}
          </Grid>
        </>
      ) : (
        <Grid
          size={{ xs: 12 }}
          sx={{
            backdropFilter: 'blur(17.128063201904297px)',
            background: 'rgba(31, 29, 58, 0.1)',
            padding: '5px',
            borderRadius: '20px 20px 0 0'
          }}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid size={{ xs: 8 }} sx={{ display: 'flex', alignItems: 'center' }}>
              {/* <Avatar
                alt={userData?.handle}
                src={
                  userData?.defaultAvatar
                    ? `${process.env.REACT_APP_DEFAULT_AVATAR}/APP/UserAvatars/Avatar2.png`
                    : `${process.env.REACT_APP_DEFAULT_AVATAR}/${userData?.uid}/PROFILE/IMAGES/medium/${userData?.avatar}`
                }
                sx={{ width: 30, height: 30 }}
                onClick={() => navigate(`/user/${userData?.handle}`)}
              /> */}
              <ProfileImageBlur
                defaultAvatar={userData && userData?.defaultAvatar}
                imgHeight={'50px'}
                imgWidth={'50px'}
                uid={userData && userData.uid}
                avatar={userData && userData.avatar}
                handle={userData && userData?.handle}
              />
              <Typography variant="inherit" color="rgba(255, 254, 254, 1)" pl={1} gutterBottom>
                {userData?.firstname || 'Anonymous'}
              </Typography>
            </Grid>
            <Grid size={{ xs: 4 }}>
              {badgeMap[badgeKey] && (
                <Box style={{ display: 'flex' }}>
                  {showDiamond && <Player autoplay loop src={diamond} style={{ width: '30px', height: '30px' }} />}
                  <Player autoplay loop src={badgeMap[badgeKey]} style={{ width: '30px', height: '30px' }} />
                </Box>
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default UserDetails;
